import React, { useState, useEffect } from "react";
import { Modal, Table, Tag, Card, Spin, Badge } from "antd";
import dayjs from "dayjs";

interface Props {
  open: boolean;
  onClose: () => void;
  isLoginHistoryModalDataLoading: boolean;
  loginHistoryModalData: any[];
  loginHistoryDataTotal: number;
  onPaginationChange: (page: number, size: number) => void;
}

const LoginHistoryModal: React.FC<Props> = ({
  open,
  onClose,
  isLoginHistoryModalDataLoading,
  loginHistoryModalData,
  loginHistoryDataTotal,
  onPaginationChange,
}) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
  });

  useEffect(() => {
    if (!open) {
      setPagination({
        current: 1,
        pageSize: 100,
      });
    }
  }, [open]);

  const columns = [
    {
      title: "Process Type",
      dataIndex: "eodBodProcessType",
      width: "16.66%",
      align: 'center' as const ,
      render: (value: any) => (value ? value : "-"),
    },
    {
      title: "Scheme",
      dataIndex: "schemeName",
      width: "16.66%",
      align: 'center' as const ,
      render: (value: any) => (value ? value : "-"),
    },
    {
      title: "Hospital Name",
      dataIndex: "hospitalName",
      width: "16.66%",
      align: 'center' as const ,
      render: (value: any) => (value ? value : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "16.66%",
      align: 'center' as const ,
      render: (status: string) => (
        <Tag
          color={status?.toLowerCase() === "success" ? "green" : "orange"}
          style={{
            display: "inline-flex",
            alignItems: 'center' as const,
            gap: 6,
            borderRadius: "999px",
            padding: "2px 12px",
          }}
        >
          <Badge
            color={status?.toLowerCase() === "success" ? "green" : "orange"}
          />
          {status ?? "-"}
        </Tag>
      ),
    },
    {
      title: "Timestamp",
      dataIndex: "loginTime",
      width: "16.66%",
      align: 'center' as const ,
      render: (_: any, record: any) => {
        return record?.loginTime
          ? dayjs.utc(record.loginTime).local().format("DD-MM-YYYY hh:mm A")
          : "-";
      },
    },
    {
      title: "Initiated By",
      dataIndex: "createdByName",
      width: "16.66%",
      align: 'center' as const,
      render: (value: any) => (value ? value : "-"),
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNumber",
      width: "16.66%",
      align: 'center' as const,
      render: (value: any) => (value ? value : "-"),
    },
  ];

  const SCALE = 0.67;

  const [scrollY, setScrollY] = useState(window.innerHeight / SCALE - 210);

  useEffect(() => {
    const handleResize = () => {
      setScrollY(window.innerHeight / SCALE - 210);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={"100vw"}
      title="Login History :"
      wrapClassName="management-age-stage-table-modal"

      bodyStyle={{
        height: "calc(144vh - 55px)",
        overflow: "auto",
        padding: 0,
      }}

      style={{
        top: 10,
        left: 4,
        padding: 0,
        maxWidth: "100vw",
        height: "145vh",
      }}
    >
      <Card>
        <Spin spinning={isLoginHistoryModalDataLoading}>
          <Table
            columns={columns}
            dataSource={loginHistoryModalData}
            rowKey={(record: any, index) => record?.id || index}
            tableLayout="fixed"
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: loginHistoryDataTotal,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              onChange: (page, pageSize) => {
                setPagination({ current: page, pageSize });
                onPaginationChange(page, pageSize);
              },
            }}
            scroll={{
            x: 150,
            y: scrollY,
          }}
            size="middle"
            style={{ maxHeight: "500px" }}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "ant-table-row-light" : ""
            }
          />
        </Spin>
      </Card>
    </Modal>
  );
};

export default LoginHistoryModal;
